import { useState } from "react"
import axios from "axios"
import { extendTheme } from "@chakra-ui/react"
import defaultTheme from "./default-theme"

function useThemes() {
  let theme_ = {}
  let theme_name = process.env.THEME_ID
  try {
    const theme_config = JSON.parse(process.env.THEME_CONFIG)
    theme_ = extendTheme({
      ...defaultTheme, ...theme_config,
      styles: {
        global: {
          body: {
            fontFamily: null,
            lineHeight: null,
            fontSize: null,
            fontColor: null,
            fontWeight: null,
          }
        }
      }
    })
  } catch (error) {
    theme_ = extendTheme({
      ...defaultTheme,
      styles: {
        global: {
          body: {
            fontFamily: null,
            lineHeight: null,
            fontSize: null,
            fontColor: null,
            fontWeight: null,
          }
        }
      }
    })
  }

  const [theme, setTheme] = useState(theme_)


  //Default locale is en
  const fetchTheme = () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache", // Prevent caching
      },
      withCredentials: true,
    }
    axios
      .get(
        `/a/courses/__themes__/${theme_name}.json`,
        config,
      )
      .then(function (response) {
        if (response.data) {
          setTheme((current_theme) => {
            return extendTheme({
              ...current_theme,
              ...response.data,
              styles: {
                global: {
                  body: {
                    fontFamily: null,
                    lineHeight: null,
                    fontSize: null,
                    fontColor: null,
                    fontWeight: null,
                  }
                }
              }
            })
          })

        }
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  return { theme, fetchTheme }
}
export default useThemes
